import React from 'react';
import LogIcon from 'modules/emergencies/components/log/LogIcon';
import { TextLog } from 'modules/emergencies/components/ui/texts/LogText';
import { LogTitleContainer } from 'modules/emergencies/components/ui/containers/logTitleContainer';
import { FormatPrice } from 'utils/format';
import { IntlProvider } from 'react-intl';

const QuoteLogTitle = ({ titleData = {}, title, icon }) => {
  const { hasSubtitle, log } = titleData;
  const price = log.action_object?.data?.price || {};
  const value = price.amount;
  const currency = price.currency;

  return (
    <LogTitleContainer>
      <LogIcon icon={icon} />
      <TextLog color="#263340">{title}</TextLog>
      {hasSubtitle && (
        <TextLog color="#54708C">
          /{' '}
          {value ? (
            <IntlProvider>
              <FormatPrice value={value} currency={currency} />
            </IntlProvider>
          ) : (
            '-'
          )}
        </TextLog>
      )}
    </LogTitleContainer>
  );
};

export default QuoteLogTitle;
